module.exports = __webpack_public_path__ + "static/media/landing@1x.775447c9.mov";